export default __webpack_public_path__ + "static/media/Group 73.8bebc046.png";